/* eslint-disable max-len */
import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

export const YandexLogo: FC<SVGProps> =({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1590_90)">
        <path d="M0.77832 9.99949C0.77832 4.88561 4.92277 0.740234 10.0376 0.740234C15.1505 0.740234 19.2968 4.88561 19.2968 9.99949C19.2968 15.1134 15.1505 19.2588 10.0376 19.2588C4.92277 19.2588 0.77832 15.1134 0.77832 9.99949Z" fill="#FC3F1D"/>
        <path d="M11.2214 5.98704H10.3658C8.79732 5.98704 7.97232 6.78148 7.97232 7.95278C7.97232 9.27685 8.54269 9.89722 9.71398 10.6926L10.6816 11.3444L7.90102 15.4991H5.82324L8.31861 11.7824C6.88343 10.7537 6.07787 9.75463 6.07787 8.06481C6.07787 5.9463 7.55472 4.5 10.3557 4.5H13.1362V15.4889H11.2214V5.98704Z" fill="white"/>
      </g>
      <defs>
        <clipPath id="clip0_1590_90">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  </SvgWrapper>
);